import apiBase from './ApiBase'

class RiskIntelligenceAPIService {
     getHotspotsArea = () => apiBase.get('/areas')
     getListofAllPorts = () => apiBase.get('/GetPortInformation')
     getPortInformationById = (id) => apiBase.get(`/GetPortInformation/${id}`)
     getIncidentAlerts = (startDate,endDate) => apiBase.get(`/incidents?from=${startDate}${endDate ? "&to="+endDate :''}`)
     getdetailsByid = (id) => apiBase.get(`/ports/${id}/security-risk-assessment`)
     getHotspotThreatsAssessment = (id) => apiBase.get(`/areas/${id}/threat-assessment`)
}

export default new RiskIntelligenceAPIService()
